@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1em;
    margin-top: 2em;
    margin-bottom: 2em;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: repeat(1, 1fr);
    }
}

.birthdayFields {
    display: flex;
    gap: 1em;

    div {
        flex-grow: 1;
    }
}

.dropdown {
    composes: defaultInput from "../../styles/composable/forms.module.css";
}

.labelText {
    text-transform: uppercase;
    white-space: nowrap;
}

.legalWrapper {
    border-bottom: 1px solid var(--color-silver);
    padding: 0 0 2rem;
    margin-bottom: 1rem;
}

.legalFieldWrapper {
    & a {
        color: black;
    }
}

.actions {
    grid-column: 1 / span 2;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 1;
    }
}

.send {
    composes: button from "../../styles/buttons.module.scss";
}
